<template>
    <svg width="186" height="186" viewBox="0 0 186 186" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
            <circle fill="#01A593" cx="93" cy="93" r="93"/>
            <path d="M93.5 94c14.083 0 25.5-11.416 25.5-25.5S107.583 43 93.5 43 68 54.417 68 68.5 79.417 94 93.5 94zm-.5 49c22.09 0 40-17.614 40-39.343 0-21.728-17.908 0-40 0-22.09 0-40-21.728-40 0S70.909 143 93 143z" fill="#FFF" fill-rule="nonzero"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'IconParent',
};
</script>
